// La vigilancia de la salud se trabaja por centro de trabajo: primero se elige la empresa y luego uno de sus
// centros (como en Recursos). Va aparte de los demás modelos porque lo usa el interceptor global.

/** Empresa y centro de trabajo con los que se está trabajando. */
export interface CentroSeleccionado {
  int_empresa_id: number;
  int_centro_id: number;
}

// ".../vigilancia_salud/empresa/<empresa cifrada>/centro/<centro cifrado>/..."
export const RUTA_EMPRESA = 'empresa';
export const RUTA_CENTRO = 'centro';
export const PARAM_EMPRESA = 'empresa';
export const PARAM_CENTRO = 'centro';

// rutas hijas de un centro (el submenú)
export const RUTA_EVALUACIONES = 'evaluaciones';
export const RUTA_ACUERDOS = 'acuerdos';
export const RUTA_BASE_CERTIFICADOS = 'base-certificados';
export const RUTA_REPORTES = 'reportes';

// Rutas de la API que separan sus datos por empresa y centro (CIE-10 y CIUO son catálogos comunes).
export const RUTAS_API_POR_CENTRO = [
  '/evaluacion-medica-ocupacional',
  '/autorizacion-datos-salud',
  '/certificado-evaluacion-medica',
  '/acuerdo-confidencialidad',
  '/vacunacion',
  '/hoja-evolucion',
  '/base-certificados',
  '/reportes-salud',
  '/dotacion-mensual',
];

export function mismoCentro(a: CentroSeleccionado | null, b: CentroSeleccionado | null): boolean {
  return a?.int_empresa_id === b?.int_empresa_id && a?.int_centro_id === b?.int_centro_id;
}
